import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_DatabaseIntegrityIssues = {
    vv1: {
        uploadIssues: { method: HttpMethod.POST, path: 'v1/database-integrity-issues/report-db-integrity-issue' },
    }
};
//# sourceMappingURL=apis.js.map